(function () {
      var root = document.getElementById('lp-cleaning-kit-root');
      var wrapper = document.getElementById('lp-cleaning-kit-page-wrapper');
      var wrapperSp = document.getElementById('lp-cleaning-kit-page-wrapper-sp');
      var BASE_PC = 1458;
      var BASE_SP = 375;
      if (!root || !wrapper || !wrapperSp) return;

      function getViewportWidth() {
        return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
      }

      function applyDesktop() {
        var vw = getViewportWidth();
        var scale = Math.min(1, vw / BASE_PC);
        var visualWidth = BASE_PC * scale;
        var offsetLeft = Math.max(0, (vw - visualWidth) / 2);

        wrapper.style.transform = 'translateX(' + offsetLeft + 'px) scale(' + scale + ')';
        wrapperSp.style.transform = 'none';
        root.style.height = Math.ceil(wrapper.offsetHeight * scale) + 'px';
      }

      function applyMobile() {
        var vw = getViewportWidth();
        var scale = vw / BASE_SP;

        wrapper.style.transform = 'none';
        wrapperSp.style.transform = 'scale(' + scale + ')';
        root.style.height = Math.ceil(wrapperSp.offsetHeight * scale) + 'px';
      }

      function applyAll() {
        if (getViewportWidth() <= 768) {
          applyMobile();
        } else {
          applyDesktop();
        }
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', applyAll);
      } else {
        applyAll();
      }
      window.addEventListener('load', applyAll);
      window.addEventListener('resize', applyAll);
    })();